import type { IWorkOrder } from '@/models/WorkOrder/IWorkOrder'

export function isClosed(workOrder: IWorkOrder | null | undefined) {
  return workOrder && workOrder.Status?.toLowerCase().includes('closed')
}

export function getDescriptionSummary(workOrder: IWorkOrder) {
  const maxLength = 30
  if (!workOrder.CaseDescription) {
    return { wrappedDesc: workOrder.CaseDescription, wrapped: false }
  }
  return workOrder.CaseDescription?.length > maxLength
    ? { wrappedDesc: workOrder.CaseDescription.substring(0, maxLength - 1) + '...', wrapped: true }
    : { wrappedDesc: workOrder.CaseDescription, wrapped: false }
}

export function buildDynamicsUriPathForWo(workOrderId: string) {
  return `?pagetype=entityrecord&etn=msdyn_workorder&id=${workOrderId}`
}

export function getSubStatus() {
  return [
    'Closed - Cancelled',
    'Closed - Resolved',
    'Closed - Unresolved',
    'Closed - Withdrawn',
    'New',
    'Pending - Allego',
    'Pending - Grid operator',
    'Pending - Replacement/ installation',
    'Pending - Site visit',
    'Pending Solution/TC',
    'Pending - Spareparts',
    'Pending - ETA',
    'Resolved - Open'
  ]
}
